const stringConversion = <T>(toConvert: string | T): string =>
  (typeof toConvert === 'string' ? JSON.parse(toConvert) : JSON.stringify(toConvert));

export default stringConversion;
